import {
  listCategories as publicListCategories,
  createCategory as publicCreateCategory,
  updateCategory as publicUpdateCategory,
  deleteCategory as publicDeleteCategory,
} from './bookings-v1-category-categories.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onCategoryNotification as publicOnCategoryNotification } from './bookings-v1-category-categories.public.js';

export const listCategories: MaybeContext<
  BuildRESTFunction<typeof publicListCategories> & typeof publicListCategories
> = /*#__PURE__*/ createRESTModule(publicListCategories);
export const createCategory: MaybeContext<
  BuildRESTFunction<typeof publicCreateCategory> & typeof publicCreateCategory
> = /*#__PURE__*/ createRESTModule(publicCreateCategory);
export const updateCategory: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCategory> & typeof publicUpdateCategory
> = /*#__PURE__*/ createRESTModule(publicUpdateCategory);
export const deleteCategory: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCategory> & typeof publicDeleteCategory
> = /*#__PURE__*/ createRESTModule(publicDeleteCategory);
/** @deprecated */
export const onCategoryNotification: BuildEventDefinition<
  typeof publicOnCategoryNotification
> &
  typeof publicOnCategoryNotification = createEventModule(
  publicOnCategoryNotification
);

export {
  Status,
  Event,
  WebhookIdentityType,
} from './bookings-v1-category-categories.universal.js';
export {
  Category,
  ListCategoryRequest,
  ListCategoryResponse,
  CategoryNotification,
  CreateCategoryRequest,
  CreateCategoryResponse,
  BatchCreateCategoryRequest,
  BatchCreateCategoryResponse,
  UpdateCategoryRequest,
  UpdateCategoryResponse,
  DeleteCategoryRequest,
  DeleteCategoryResponse,
  BatchDeleteCategoryRequest,
  BatchDeleteCategoryResponse,
  BatchUpdateCategoryRequest,
  BatchUpdateCategoryResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  CategoryNotificationEnvelope,
  ListCategoriesOptions,
  UpdateCategory,
  DeleteCategoryOptions,
} from './bookings-v1-category-categories.universal.js';
export {
  StatusWithLiterals,
  EventWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateCategoryApplicationErrors,
} from './bookings-v1-category-categories.universal.js';
